

(function($){

    if ( $('.child-pages-group').has('.child-page')) {

        // get each group individually
        $('.child-pages-group').each(function() {

            // get number of child pages in group
            var childPagesCount = $('.child-page', this).length;
            
            // check if odd number
            if (childPagesCount & 2 != 0) {
                // apply class to first child page
                $('.child-page', this).first().closest('.wp-block-group').addClass('first-child');
            }
        });        
    }
    

})(jQuery);